import "../layouts/default"

var map;
var markerCluster
//var geocoder;
var markers_all = [];
var markers_add = [];
var markers_remove = [];
var openedInfowindow;



function initMap() {
    map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(48.65, 19.65),
        zoom: 8
    });

    //geocoder = new google.maps.Geocoder();

    markers_all = [];
    markers_data.forEach(function(item) {
        var marker;

        marker = null;
        if(item.latitude && item.longitude) {
            var latLng = new google.maps.LatLng(item.latitude,
                item.longitude);
            marker = new google.maps.Marker({
                position: latLng,
                metadata: item,
                title: item.name,
                icon: '/img/icons/marker.png',
                infowindow: new google.maps.InfoWindow({
                    content: `
                    <div class="c-store">
                        <div class="c-store__place">${item.street2} - ${item.city}</div>
                        <div class="c-store__name">${item.name}</div>
                        <div class="c-store__data">
                            <div class="c-item">
                                <strong>Adresa:</strong>
                                ${item.street}<br>${item.post_code} ${item.city}

                                <strong>E-mail:</strong>
                                <a href="mailto:${item.email}" class="c-link">${item.email}</a>

                                <strong>Tel. č.:</strong>
                                <a href="tel:${item.phone}" class="c-link">${item.phone}</a>
                            </div>

                            <div class="c-item">
                                <strong>Otváracie hodiny:</strong>
                                <table>
                                    <tr>
                                        <th>Po:</th>
                                        <td>${item.pondelok}</td>
                                    </tr>
                                    <tr>
                                        <th>Ut:</th>
                                        <td>${item.utorok}</td>
                                    </tr>
                                    <tr>
                                        <th>St:</th>
                                        <td>${item.streda}</td>
                                    </tr>
                                    <tr>
                                        <th>Št:</th>
                                        <td>${item.stvrtok}</td>
                                    </tr>
                                    <tr>
                                        <th>Pi:</th>
                                        <td>${item.piatok}</td>
                                    </tr>
                                    <tr>
                                        <th>So:</th>
                                        <td>${item.sobota}</td>
                                    </tr>
                                    <tr>
                                        <th>Ne:</th>
                                        <td>${item.nedela}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    `
                })
            });
        }
        // else {
        //     if(!item.address) {
        //         item.address = item.mesto;
        //     }
        //     geocoder.geocode({'address': item.address}, function(results, status) {
        //         if (status === 'OK') {
        //             map.setCenter(results[0].geometry.location);
        //             var marker = new google.maps.Marker({
        //                 map: map,
        //                 position: results[0].geometry.location
        //             });
        //         } else {
        //             console.log('Geocode was not successful for the following reason: ' + status);
        //         }
        //     });
        // }

        if(marker) {
            marker.addListener("click", () => {
                if (openedInfowindow) {
                    openedInfowindow.close();
                }

                marker.infowindow.open(map, marker);
                openedInfowindow = marker.infowindow;
            });

            markers_all.push(marker);
        }

    });

    google.maps.event.addListener(map, 'click', function () {
        if (openedInfowindow) {
            openedInfowindow.close();
        }
    });

    markerCluster = new MarkerClusterer(map, [], {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });

    onChangeKraj();
}

function applyFilter()
{
    var selectedKraj = $('#map-filter-kraj option:selected').attr('value');
    var selectedMesto = $('#map-filter-mesto option:selected').attr('value');

    var dnes = $('[name="dnes"]').is(':checked');
    var sobota = $('[name="sobota"]').is(':checked');
    var nedela = $('[name="nedela"]').is(':checked');
    var pickup = $('[name="pickup"]').is(':checked');

    markers_all.forEach(function(marker) {
        var enabled = true;

        if(selectedKraj) {
            if(marker.metadata.street2 != selectedKraj) {
                enabled = false;
            }
        }

        if(selectedMesto) {
            if(marker.metadata.city != selectedMesto) {
                enabled = false;
            }
        }

        if(dnes) {
            var today = new Date();
            var day = today.getDay();
            var hours = '';

            switch(day) {
                case 1: hours = marker.metadata.pondelok; break;
                case 2: hours = marker.metadata.utorok; break;
                case 3: hours = marker.metadata.streda; break;
                case 4: hours = marker.metadata.stvrtok; break;
                case 5: hours = marker.metadata.piatok; break;
                case 6: hours = marker.metadata.sobota; break;
                case 0: hours = marker.metadata.nedela; break;
            }

            if(!isOpenedHours(hours)) {
                enabled = false;
            }

        }

        if(sobota) {
            if(marker.metadata.sobota.toLowerCase() == 'zatvorené') {
                enabled = false;
            }
        }

        if(nedela) {
            if(marker.metadata.nedela.toLowerCase() == 'zatvorené') {
                enabled = false;
            }
        }

        if(pickup) {
            if(!marker.metadata.is_pickup) {
                enabled = false;
            }
        }

        if(enabled) {
            if (markerCluster.getMarkers().indexOf(marker) < 0) {
                markers_add.push(marker);
                $('#map-list .detail-' + marker.metadata.id).show();
            }
        }
        else {
            if (markerCluster.getMarkers().indexOf(marker) >= 0) {
                markers_remove.push(marker);
                $('#map-list .detail-' + marker.metadata.id).hide();
            }
        }
    })

    if(markers_remove.length) {
        markerCluster.removeMarkers(markers_remove, false);
        markers_remove = [];
    }
    if(markers_add.length) {
        markerCluster.addMarkers(markers_add, false);
        markers_add = [];
    }
    //markerCluster.redraw();
    if(markerCluster.getMarkers().length) {
        markerCluster.fitMapToMarkers();
    }

    // toggle empty msg
    if ($('.c-stores__item:visible').length) {
        $('.js-stores-empty').addClass('is-hidden');
    }
    else {
        $('.js-stores-empty').removeClass('is-hidden');
    }
}


function pharmacy_detail(pharmacy)
{
    $('#modal-pharmacy .modal-title').html(pharmacy.title);
    $('#modal-pharmacy .modal-body .modal-pharmacy-title').html(pharmacy.title);
    $('#modal-pharmacy .modal-body .modal-pharmacy-kraj').html(pharmacy.kraj);
    $('#modal-pharmacy .modal-body .modal-pharmacy-mesto').html(pharmacy.mesto);

    var address = '<strong>Kontakty</strong><br />' + pharmacy.ulica + '<br />' + pharmacy.psc + ' ' + pharmacy.mesto + '<br />';

    address += '<strong>E-mail: ' + '</strong>' + pharmacy.email + '<br /><strong>Tel.: </strong>' + pharmacy.telefon

    var hours = '<strong>OtvĂˇracie hodiny</strong><br />';

    if(pharmacy.pondelok == pharmacy.utorok && pharmacy.pondelok == pharmacy.streda && pharmacy.pondelok == pharmacy.stvrtok && pharmacy.pondelok == pharmacy.piatok) {
        hours += 'Pondelok - Piatok: ' + pharmacy.pondelok + '<br />';
    }
    else {
        hours += 'Pondelok: ' + pharmacy.pondelok + '<br />';
        hours += 'Utorok: ' + pharmacy.utorok + '<br />';
        hours += 'Streda: ' + pharmacy.streda + '<br />';
        hours += 'Ĺ tvrtok: ' + pharmacy.stvrtok + '<br />';
        hours += 'Piatok: ' + pharmacy.piatok + '<br />';
    }

    if(pharmacy.sobota == pharmacy.nedela) {
        hours += 'Sobota - NedeÄľa: ' + pharmacy.sobota + '<br />';
    }
    else {
        hours += 'Sobota: ' + pharmacy.sobota + '<br />';
        hours += 'NedeÄľa: ' + pharmacy.nedela + '<br />';
    }

    hours = hours.replace(/;/g, ' ');

    $('#modal-pharmacy .modal-body .modal-title-info .hours').html(hours);
    $('#modal-pharmacy .modal-body .modal-title-info .address').html(address);

    var map;

    map = new google.maps.Map(document.getElementById('map-detail'), {
        center: new google.maps.LatLng(pharmacy.latitude, pharmacy.longitude),
        zoom: 18
    });

    var latLng = new google.maps.LatLng(pharmacy.latitude,
        pharmacy.longitude);
    var marker = new google.maps.Marker({
        position: latLng,
        title: pharmacy.title,
        icon: '/buxus/images/design-2018/marker.png',
        map: map
    });


    $('#modal-pharmacy').modal('show');
}

function onChangeKraj()
{
    var selectedKraj = $('#map-filter-kraj option:selected').attr('value');
    var selectedMesto = $('#map-filter-mesto option:selected').attr('value');

    var options = '<option>Vyberte mesto</option>';

    if(selectedKraj) {
        kraje.forEach(function(kraj) {
            if(kraj == selectedKraj) {
                var mesta = new Set();

                markers_data.forEach(function (marker) {
                    if (marker.street2 != selectedKraj || mesta.has(marker.city)) {
                        return;
                    }

                    options += '<option value="' + marker.city + '">' + marker.city + '</option>';
                    mesta.add(marker.city);
                });
            }
        });

    }
    else {
        mesta.forEach(function(mesto) {
            options += '<option value="' + mesto + '">' + mesto + '</option>';
        });
    }

    $('#map-filter-mesto').html(options);

    applyFilter();
}

function onChangeMesto()
{
    applyFilter();
}

function onClickFilterButton(e, btn)
{
    e.preventDefault();

    if(!$(btn).hasClass('btn-danger')) {
        $(btn).addClass('btn-danger').removeClass('btn-primary').addClass('on');
        applyFilter();
    }
    else {
        $(btn).addClass('btn-primary').removeClass('btn-danger').removeClass('on');
        applyFilter();
    }


}

function isOpenedHours(str)
{
    if(str == 'zatvorené') {
        return(false);
    }

    //console.log('HOURS: ' + str);

    var hours = str.split(";");

    var opened = false;

    hours.forEach(function(str) {
        str = str.trim();
        var exploded = str.split('-');

        var start = exploded[0].trim();
        var stop = '23:59';

        if(exploded.length > 1) {
            stop = exploded[exploded.length - 1].trim();
        }

        var start_exploded = start.split(':');
        var stop_exploded = stop.split(':');
        var start_hours = parseInt(start_exploded[0].trim());
        var start_mins = '0';
        var stop_hours = parseInt(stop_exploded[0].trim());
        var stop_mins = '0';

        if(isNaN(start_hours)) {
            start_hours = 0;
        }

        if(start_exploded[1]) {
            start_mins = parseInt(start_exploded[1].trim());
        }
        if(stop_exploded[1]) {
            stop_mins = parseInt(stop_exploded[1].trim());
        }

        //console.log('result: ' + start_hours + ':'  + start_mins + ' - ' + stop_hours + ':' + stop_mins);

        var now = new Date();

        var now_hour = parseInt(now.getHours());
        var now_mins = parseInt(now.getMinutes());

        if(now_hour > start_hours && now_hour < stop_hours) {
            opened = true;
        }
        if(now_hour == start_hours) {
            if(now_mins >= start_mins) {
                if(now_hour == stop_hours) {
                    if(now_mins < stop_mins) {
                        opened = true;
                    }
                }
                else {
                    opened = true;
                }
            }
        }

        if(now_hour == stop_hours) {
            if(now_mins < stop_mins) {
                opened = true;
            }
        }

    });

    return(opened);

}

window.initMap = initMap;
window.onChangeKraj = onChangeKraj;
window.onChangeMesto = onChangeMesto;
window.onClickFilterButton = onClickFilterButton;
window.applyFilter = applyFilter;